export default {"src":"/_next/static/media/downArrow.cd0e6f56.svg","height":5,"width":9};